export default __webpack_public_path__ + "static/media/setion07_kv02.993fda40.png";